'use client';

import { useEffect } from 'react';
import useVelocityClient from 'src/hooks/useVelocityClient';
import useVelocityClientIsReady from 'src/hooks/useVelocityClientIsReady';
import {
	getDriftVaultProgram,
	VaultClient,
} from '@velocity-exchange/vaults-sdk';
import useVelocityStore from '../VelocityStore/useVelocityStore';
import { createPlaceholderIWallet } from '@velocity-exchange/common';
import { useVaultsStore } from './useVaultsStore';
import { ENABLE_STRATEGY_VAULTS } from 'src/constants/featureGates';

export const useSyncVaultClient = () => {
	const velocityClient = useVelocityClient();
	const velocityClientIsReady = useVelocityClientIsReady();
	const connection = useVelocityStore((s) => s.connection.current);
	const setVaultsStore = useVaultsStore((s) => s.set);

	useEffect(() => {
		if (!ENABLE_STRATEGY_VAULTS) return;

		if (velocityClientIsReady && velocityClient && connection) {
			const vaultProgram = getDriftVaultProgram(
				connection,
				createPlaceholderIWallet()
			);
			const vaultClient = new VaultClient({
				driftClient: velocityClient,
				program: vaultProgram,
			});
			setVaultsStore((s) => {
				s.vaultClient = vaultClient;
			});
		}
	}, [velocityClient, velocityClientIsReady, connection]);
};
